import { render, staticRenderFns } from "./Concierge.vue?vue&type=template&id=8248ae1c"
import script from "./Concierge.vue?vue&type=script&lang=js"
export * from "./Concierge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports